import React, { useCallback, useEffect, useRef } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { EmptyListPage, TableHeader, TableLoader } from "../../commons";
import { BULK_UPLOAD_HISTORY_LIST_HEADERS } from "../../../constant/tableHeadersConstants/invoiceGenerationConstants/invoicesListConst";
import BulkUploadData from "./BulkUploadData";
import { EmptyTimeSheetReportList } from "../../../assets/images";
import { BulkUploadHistoryDataType } from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import BulkUploadDetails from "./BulkUploadDetails";
import { GetGenerateSasTokenPayloadType } from "../../../commonTypes/stcoToolsType";

type AppProps = {
  offset: number;
  limit: number;
  setOffset: (data: number) => void;
  isBulkHistory: boolean;
  toogleBulkHistoryModal: () => void;
  historyData: BulkUploadHistoryDataType[] | [];
  fetching: boolean;
  token: string | null;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
  sasTokenForDownloadFile: string;
  dispatchResetSasTokenForDownloadFile: () => void;
};

const BulkHistoryModal = ({
  isBulkHistory,
  toogleBulkHistoryModal,
  historyData,
  fetching,
  offset,
  setOffset,
  limit,
  sasTokenForDownloadFile,
  dispatchResetSasTokenForDownloadFile,
  dispatchGetTokenGenerateForDownloadAction,
  token,
}: AppProps) => {
  const scrollRef = useRef<any>("");

  const handleScrolll = useCallback(
    (event: any) => {
      const scrollTop = scrollRef.current.scrollTop;
      const scrollHeight = scrollRef.current.scrollHeight;
      const clientHeight = scrollRef.current.clientHeight;
      if (Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight) {
        if (historyData?.length > 0) {
          setOffset(offset + limit);
        }
      }
      /* eslint-disable react-hooks/exhaustive-deps */
    },
    [historyData]
  );

  useEffect(() => {
    let scrollRefData = scrollRef.current;
    if (scrollRefData) {
      scrollRef.current.addEventListener("scroll", handleScrolll);
      return () => scrollRefData.removeEventListener("scroll", handleScrolll);
    }
  }, [historyData]);

  return (
    <div>
      <Modal
        centered
        isOpen={isBulkHistory}
        toggle={toogleBulkHistoryModal}
        size="xl"
        backdrop="static"
      >
        <ModalHeader
          className="pt-4 pl-4"
          id="cross-cut"
          toggle={toogleBulkHistoryModal}
        >
          Bulk Upload History
        </ModalHeader>
        <ModalBody className="pl-4 pr-4" style={{ paddingLeft: "40px" }}>
          {fetching && offset === 0 ? (
            <TableLoader Rows={5} ColumnPerRow={7} />
          ) : historyData?.length > 0 ? (
            <div
              className="new-table-style"
              ref={scrollRef}
              style={{ height: "400px", overflow: "scroll" }}
            >
              <table className="table table-bordered thead-light m-0">
                <thead className="text-start sticky-table-header">
                  <TableHeader tableHeader={BULK_UPLOAD_HISTORY_LIST_HEADERS} />
                </thead>
                <tbody>
                  <BulkUploadDetails
                    tableHeaders={BULK_UPLOAD_HISTORY_LIST_HEADERS}
                    data={historyData}
                    token={token}
                    sasTokenForDownloadFile={sasTokenForDownloadFile}
                    dispatchResetSasTokenForDownloadFile={
                    dispatchResetSasTokenForDownloadFile}
                    dispatchGetTokenGenerateForDownloadAction={
                    dispatchGetTokenGenerateForDownloadAction}
                  />
                </tbody>
              </table>
            </div>
          ) : (
            <>
              {!fetching && historyData?.length === 0 && (
                <EmptyListPage
                  title="No Bulk History Found!"
                  text="Upload some data to view history !"
                  imageWidth="30%"
                  image={EmptyTimeSheetReportList}
                  showAddButton={false}
                />
              )}
            </>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default BulkHistoryModal;
